import { isAllUS } from '../../../../../../../../../../utils/lineItem';
import type { LineItemEntity } from '../../../../../../types';

export const getBufferChangeText = (entity: LineItemEntity): string => {
  const isNonUS = !isAllUS(entity.countries);

  if (entity.automateBuffer === true && !isNonUS) {
    const automatedBuffer = entity.automatedDeliveryBufferPercent ?? 0;
    return `Automated ${automatedBuffer.toFixed(2)}%`;
  }

  if (isNonUS || entity.automateBuffer === false) {
    const manualBuffer = entity.deliveryBufferPercent ?? 0;
    return `User-Applied ${manualBuffer.toFixed(2)}%`;
  }

  if (entity.deliveryBufferPercent !== null) {
    const buffer = entity.deliveryBufferPercent ?? 0;
    return `${buffer.toFixed(2)}% buffer`;
  }

  return 'no changes';
};
